import { useDialogs } from "@src/hooks/dialog";
import { QueryMeta } from "@src/types/react-query";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { organizationDomainKey } from "../queryKeys";

const getShopDomain = async () => {
  const resp = await api.get<string>("/v2/shops/domain");
  return resp.data;
};

export const useGetShopDomain = () => {
  const org = useGetOrg();
  const { openDialog } = useDialogs();

  return useQuery<string, Error>({
    queryKey: organizationDomainKey.one(org.data.org.id),
    queryFn: async () => getShopDomain(),
    meta: {
      onSuccess: (data: string | undefined) => {
        if (!data) {
          openDialog("setDomain");
        }
      },
    } as QueryMeta,
  });
};
